import React, { useState } from "react"; //
import {
  //
  bearlog,
  BearDiv,
} from "@sillyscribe95/bear-ui-web";
import Keyboard from "react-virtual-keyboard";

export function KeyboardComp() {
  //
  let sdofw =
    //
    "alpha";

  const dqwsa = {
    type: sdofw,
    layout: "qwerty",
    // alwaysOpen: true,
    usePreview: false,
    useWheel: false,
    stickyShift: false,
    appendLocally: true,
    color: "light",
    updateOnChange: true,
    // initialFocus: true,
    display: {
      q: "Asdqwea",
      accept: "Submit",
    },
  };

  //   1value
  const [sdfavc, setsdfavc] = useState();

  // 1onchange 1change
  function sdfger(sdfgs) {
    bearlog.lug("___ onchnge ___", sdfgs);

    //
  }

  function dfgfid(params) {
    bearlog.lug("___ sbmmit ___", params);
  }

  const swfsdd = {
    // value
    onChange: sdfger,
    onAccepted: dfgfid,
  };

  const iwasde = {
    ...swfsdd,
    name: "keyboard",
    options: dqwsa,
    //   ref={(k) => (this.keyboard = k)}
  };

  const okfdsd = <Keyboard {...iwasde} />;

  return okfdsd;
}
